import { createGlobalStyle } from 'styled-components';

import { NAVBAR_HEIGHT } from './constants/ui';

import * as Fonts from './attrs/fonts';
import * as Colors from './attrs/colors';

const GlobalStyle = createGlobalStyle`
  ::selection {
    background-color: ${Colors.BLUE};
  }

  html, body {
    font-size: 14px;
  }

  body {
    font-family: ${Fonts.PRIMARY};
    background: ${Colors.GREY_90};
    color: ${Colors.GREY};
    padding-top: ${NAVBAR_HEIGHT}px;
    overflow-y: scroll;
  }

  a {
    color: ${Colors.BLACK};
  }
`;

export default GlobalStyle;
